import { observer } from 'mobx-react-lite';
import {
    writeAccessOptionsGroupText,
    createItemsAccessOptionText,
    createSubfolderAccessOptionText,
    ownerEditAccessOptionText,
    allEditAccessOptionText,
} from './FolderPermissionFormEditGroup.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import Permission from 'owa-service/lib/contract/Permission';

import { changeFolderPermissionProperty } from '../actions/internalActions';
import PERMISSION_CONSTANTS from '../utils/permissionConstants';
const styles = require('./FolderPermissionForm.scss');

// Interface for defining props for the component.
interface FolderPermissionFormEditGroupProps {
    permission: Permission;
}

/**
 * This component shows Edit Group in folder permission form.
 */
export default observer(function FolderPermissionFormEditGroup(
    props: FolderPermissionFormEditGroupProps
) {
    const { permission } = props;
    return (
        <div className={styles.permissionFormPermissionsGroup}>
            <label>{loc(writeAccessOptionsGroupText)}</label>
            <>
                <Checkbox
                    checked={permission.CanCreateItems}
                    label={loc(createItemsAccessOptionText)}
                    onChange={onChangeCanCreateItems}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
                <Checkbox
                    checked={permission.CanCreateSubFolders}
                    label={loc(createSubfolderAccessOptionText)}
                    onChange={onChangeCanCreateSubFolders}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
                <Checkbox
                    checked={
                        permission.EditItems === PERMISSION_CONSTANTS.EDIT_ACCESS.OWNED ||
                        permission.EditItems === PERMISSION_CONSTANTS.EDIT_ACCESS.ALL
                    }
                    label={loc(ownerEditAccessOptionText)}
                    onChange={onChangeOwnerAccessEditItems}
                    disabled={permission.EditItems === PERMISSION_CONSTANTS.EDIT_ACCESS.ALL}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
                <Checkbox
                    checked={permission.EditItems === PERMISSION_CONSTANTS.EDIT_ACCESS.ALL}
                    label={loc(allEditAccessOptionText)}
                    onChange={onChangeAllAccessEditItems}
                    className={styles.permissionFormPermissionsGroupCheckboxOption}
                />
            </>
        </div>
    );
});

/**
 * This function is called when 'CanCreateItems' permission property is modified in the permission form.
 * @param event Event object
 * @param value Value of the property
 */
function onChangeCanCreateItems(event, value: boolean) {
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.CAN_CREATE_ITEMS, value);
}

/**
 * This function is called when 'CanCreateSubFolders' permission property is modified in the permission form.
 * @param event Event object
 * @param value Value of the property
 */
function onChangeCanCreateSubFolders(event, value: boolean) {
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.CAN_CREATE_SUB_FOLDERS, value);
}

/**
 * This function is called when 'EditItems' permission property is modified for 'Owner' access in the permission form.
 * @param event Event object
 * @param isSet If the option is selected or not
 */
function onChangeOwnerAccessEditItems(event, isSet: boolean) {
    const value = isSet
        ? PERMISSION_CONSTANTS.EDIT_ACCESS.OWNED
        : PERMISSION_CONSTANTS.EDIT_ACCESS.NONE;
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.EDIT_ITEMS, value);
}

/**
 * This function is called when 'EditItems' permission property is modified for 'All' access in the permission form.
 * @param event Event object
 * @param isSet If the option is selected or not
 */
function onChangeAllAccessEditItems(event, isSet: boolean) {
    const value = isSet
        ? PERMISSION_CONSTANTS.EDIT_ACCESS.ALL
        : PERMISSION_CONSTANTS.EDIT_ACCESS.NONE;
    changeFolderPermissionProperty(PERMISSION_CONSTANTS.PROPERTY.EDIT_ITEMS, value);
}
